module.exports = __webpack_public_path__ + "media/soundtrack.5b47f9b9.mp3";